export default __webpack_public_path__ + "static/media/Common.a3ad7451.png";